import { useMemo, useState } from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router';
import { useAgents, useCatalog } from '../api/hooks';
import { ErrorNote, Loading, PageHead } from '../components/ui';

export function AgentsPage() {
  const me = useOutletContext<{ roles: Array<{ role: string }> }>();
  const isDrh = me.roles.some((r) => r.role === 'drh');
  const agents = useAgents();
  const statuses = useCatalog('agent-statuses');
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const statusLabel = useMemo(() => new Map((statuses.data ?? []).map((s) => [s.id, s.label])), [statuses.data]);
  const rows = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return (agents.data ?? []).filter((a) => !needle || `${a.lastName} ${a.firstName} ${a.matricule}`.toLowerCase().includes(needle));
  }, [agents.data, q]);

  return (
    <>
      <PageHead
        eyebrow="Ressources humaines"
        title="Agents"
        actions={
          isDrh && (
            <Link className="btn btn-primary" to="/agents/new">
              Nouvel agent
            </Link>
          )
        }
      >
        Les agents de votre périmètre. Les données sensibles n'apparaissent jamais ici.
      </PageHead>
      <div className="field" style={{ maxWidth: 360 }}>
        <label htmlFor="agent-search">Rechercher</label>
        <input id="agent-search" placeholder="Nom, prénom ou matricule" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <ErrorNote error={agents.error} />
      {agents.isPending ? (
        <Loading />
      ) : (
        <div className="tw">
          <table>
            <thead>
              <tr>
                <th>Matricule</th>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Statut</th>
                <th>Courriel</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td colSpan={5} className="empty">
                    Aucun agent dans votre périmètre.
                  </td>
                </tr>
              )}
              {rows.map((a) => (
                <tr key={a.id} className="link" onClick={() => void navigate(`/agents/${a.id}`)}>
                  <td className="mono">{a.matricule}</td>
                  <td>
                    <strong>{a.lastName.toUpperCase()}</strong>
                  </td>
                  <td>{a.firstName}</td>
                  <td>{a.statusId ? (statusLabel.get(a.statusId) ?? '—') : '—'}</td>
                  <td className="muted">{a.email ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
